import { FC } from 'react';
import * as React from 'react';

import { clsx } from 'clsx';

import NewArrowRight from '@crehana/icons/NewArrowRight';
import { colors, transition, type BaseCuiFCProps } from '@crehana/ui';
import { scroll } from '@crehana/utils';

type ScrollTopFABProps = BaseCuiFCProps & {
  /*
   * Optional custom function on click.
   *
   * @default scrollTop from '@crehana/utils/scroll'
   */
  onScrollTop?: () => void;
};

const ScrollTopFAB: FC<React.PropsWithChildren<ScrollTopFABProps>> = ({
  className,
  onScrollTop,
  css: cssProp,
  ...scrollTopFABProps
}) => {
  const onClick = () => {
    if (typeof onScrollTop === 'function') {
      onScrollTop();
    } else {
      scroll.scrollTop();
    }
  };

  return (
    <button
      type="button"
      className={clsx(
        'flex flex-shrink-0 items-center justify-center bg-secondary-main hover:bg-secondary-light w-32 h-32 rounded-full focus:outline-none',
        className,
      )}
      css={`
        transition: ${transition('background-color')};
        & > svg {
          transform: rotate(-90deg);
        }
        ${cssProp}
      `}
      onClick={onClick}
      {...scrollTopFABProps}
    >
      <NewArrowRight color={colors.white} size={16} />
    </button>
  );
};

export default ScrollTopFAB;
